class MatchesListController {
	constructor(MatchesFactory, $rootScope, $state, $filter, ngDialog){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		vm.rootScope = $rootScope;

		vm.$onInit = () =>{
			reloadData();
		};

		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'match_name',
					name: $translate('NAME'),
					enableFiltering: true,
					width: '40%'
				}, {
					field: 'entries',
					name: $translate('ENTRIES'),
					enableFiltering: false,
				}, {
					field: 'match_date',
					name: $translate('DATE'),
					enableFiltering: false,
				}, {
					field: 'match_location',
					name: $translate('LOCATION'),
					enableFiltering: false,
				}, {
					field: 'actions',
					enableFiltering: false,
					name: $translate('ACTIONS'),
					headerCellClass: 'text-center',
					cellTemplate: '' +
					'<div class="ui-grid-cell-contents no-wrap ui-grid-align-c p-t-5">' +
					'<div class="buttons">' +
					'<button ' +
					'translate ' +
					'ng-if="grid.appScope.vm.rootScope.currentMatchId != row.entity.match_id" ' +
					'ng-click="grid.appScope.vm.selectMatch(row.entity.match_id)" ' +
					'class="btn btn-sm btn-info">ENTER</button>' +
					'<button ' +
					'translate ' +
					'class="btn btn-sm btn-warning" ' +
					'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_MATCH)" ' +
					'ng-click="grid.appScope.vm.editMatch(row.entity.match_id)">EDIT</button>' +
					'<button class="btn btn-sm btn-danger" translate ' +
					'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_MATCH)" ' +
					'ng-click="grid.appScope.vm.deleteMatch(row.entity.match_id)">DELETE</button>' +
					'</div>' +
					'</div>',
					width: '310',
				},
			],
		};

		vm.hasPermission = (permission) =>{
			return vm.rootScope.user.canDo(permission);
		};

		vm.createMatch = () =>{
			vm.rootScope.clearMatchData();
			$state.go('match-edit');
		};

		vm.editMatch = (matchId) =>{
			$state.go('match-edit', {id: matchId})
		};

		vm.selectMatch = function(matchId){
			MatchesFactory.getOne(matchId).then(response =>{
				vm.rootScope.updateMatchData(response.data);
				$state.go('match-profile', {id: vm.rootScope.currentMatchId});
			});
		};

		vm.deleteMatch = (matchId) =>{
			ngDialog.openConfirm({
				template: 'confirmTemplate',
				data: {
					message: $translate('CONFIRM_DELETE_MATCH')
				}
			}).then(() =>{
				MatchesFactory.delete(matchId).then(response =>{
					ngDialog.open({template: 'successTemplate'});
					reloadData();
					if(vm.rootScope.currentMatchId === matchId){
						vm.rootScope.clearMatchData();
					}
				});
			});
		};

		function reloadData(){
			MatchesFactory.getAll().then(response =>{
				vm.gridOptions.data = response.data;
			});
		}
	}

}

export default MatchesListController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchesList/matchesList.controller.js